import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone'; // Import useDropzone hook from react-dropzone
import { v4 as uuid } from 'uuid';

const FileUploader = ({ errorMessage, acceptedTypes, onFileUpload, onFileRead, placeholder }) => {
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null)

    const [id, setId] = useState("")
    // Handle file drop
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        onFileUpload?.(file)
        setFile(file)
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    // Parse the file contents as JSON
                    const parsedData = JSON.parse(e.target.result);
                    onFileRead?.(e.target.result)
                    setError(null); // Reset any previous errors
                } catch (err) {
                    console.log(err)
                    // Handle errors if the file is not a valid JSON
                    setError('Invalid JSON file');
                }
            };

            reader.onerror = () => {
                setError('Error reading file');
            };

            // Read the file as text
            reader.readAsText(file);
        }

    };


    useEffect(() => {
        setId(uuid())
    }, [])


    return (
        <div className="">


            <input
                type="file"
                id={id}
                hidden
                onChange={handleFileChange}
                accept={acceptedTypes?.join(",")} // Restrict to JSON files
            />
            <label
                for={id}
                class="block text-sm py-2 px-4
            rounded-md border-0 text-sm font-semibold bg-white
            border-[2px] border-[#7059ef]
            text-[#7059ef] hover:bg-[#7059ef] hover:bg-opacity-10 cursor-pointer w-[150px] text-center"
            >
                {placeholder || "Dosya Yükle"}
            </label>

        </div>
    );
};

export default FileUploader;
